import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
Dialog:{
  // maxWidth:600,
  // width:'100%'
}
}));
